import { v4 as uuidv4 } from 'uuid';
import MyConstant from './MyConstant.tsx';
const {
    ZiFetchService1Client,
    ZiFetchService2Client,
    ZiFetchService3Client,
    ZiFetchService4Client,
    ZiFetchService5Client,
    ZiFetchService6Client,
    ZiFetchService7Client,
    ZiFetchService8Client,
    ZiFetchService9Client,
    ZiFetchService10Client,
  } = require('../protobuf/generated/ZiFetchService_grpc_web_pb.js');

export function getUuidv4() {
    return uuidv4()
}

export function getGrpcClient() {

      let grpcClient1 = new ZiFetchService1Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient2 = new ZiFetchService2Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient3 = new ZiFetchService3Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient4 = new ZiFetchService4Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient5 = new ZiFetchService5Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient6 = new ZiFetchService6Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient7 = new ZiFetchService7Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient8 = new ZiFetchService8Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient9 = new ZiFetchService9Client(MyConstant.keyList.grpcURL, {}, {});
      let grpcClient10 = new ZiFetchService10Client(MyConstant.keyList.grpcURL, {}, {});
      
      const grpcClient = [grpcClient1, grpcClient2, grpcClient3, grpcClient4, grpcClient5, grpcClient6, grpcClient7, grpcClient8, grpcClient9, grpcClient10];

      return grpcClient[Math.floor(Math.random() * grpcClient.length)];
}

export function getAppInfo() {

  let appInfo = {
      appPlatform: "web",
      appVersion: "",
      buildNumber: "",
      model: "",
      bundleId: "",
      systemVersion: "",
      userAgent: navigator.userAgent
  };

  return JSON.stringify(appInfo);
}